export default __webpack_public_path__ + "static/media/AskKardia.5249cf42.jpeg";